import { Channel } from 'laravel-echo';
import { Module } from 'vuex';
import { StoreState } from '../../models/store.interface';

export interface WebSocketState {
   userChannel?: Channel;
   globalChannel?: Channel;
}

const WebSocketStore: Module<WebSocketState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USER_CHANNEL(state, channel?: Channel) {
         state.userChannel = channel;
      },
      SET_GLOBAL_CHANNEL(state, channel?: Channel) {
         state.globalChannel = channel;
      },
   },
   actions: {},
};

export default WebSocketStore;
